import { render, staticRenderFns } from "./hotel-modal.vue?vue&type=template&id=2deffa42&scoped=true"
import script from "./hotel-modal.vue?vue&type=script&lang=js"
export * from "./hotel-modal.vue?vue&type=script&lang=js"
import style0 from "./hotel-modal.vue?vue&type=style&index=0&id=2deffa42&prod&lang=scss"
import style1 from "./hotel-modal.vue?vue&type=style&index=1&id=2deffa42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deffa42",
  null
  
)

export default component.exports